import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setUnlockDomain', function setUnlockDomain(transferState: boolean) {
    store.legacyPremiumUserDomainState.isTransferredToGoDaddy = transferState;
});
